export class UtilsTools {
  static getInstance() {
    if (!this._instance) {
      this._instance = new UtilsTools();
    }
    return this._instance;
  }

  goToSelector(selector, options = {}) {
    setTimeout(() => {
      try {
        document.querySelector(selector).scrollIntoView({
          behavior: "smooth",
          ...options
        });
      } catch (e) {}
    }, 200);
  }

  pathFromLocation(location) {
    return location.pathname;
  }
}

export const ClickLink = (action, event) => {
  if (action) {
    UtilsTools.getInstance().goToSelector(action);

    if (event) {
      event.preventDefault();
    }
  }
};
